export class ConfirmationCancelAction {
  public static readonly type = '[Project/Wiki/List] ConfirmationCancelAction';
}
